import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { DirectionProvider } from "@/providers/direction-provider";
import { ThemeProvider } from "@/providers/theme-provider";
import { AuthProvider } from "@/providers/auth-provider";
import { App } from "@/app";
import { installApiInterceptor } from "@/lib/api";
import "./globals.css";

// In production, rewrite /api/* and /super/api/* to the Worker URL
installApiInterceptor();

const rootElement = document.getElementById("root");
if (rootElement === null) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <DirectionProvider>
      <ThemeProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </DirectionProvider>
  </StrictMode>,
);
